import React, { useEffect, useState } from "react";
import "./DilemaReport.css";
import CommomBanner from "../CommomBanner/CommomBanner";

function DilemaReport() {
  const [Dilemma, setDilemma] = useState([]);
  const [resultReady, setResultReady] = useState(false);

  useEffect(() => {
    if (
      Dilemma &&
      typeof Dilemma === "object" &&
      Object.keys(Dilemma).length > 0
    ) {
      setResultReady(true);
    }
  }, [Dilemma]);

  return (
    <div className="test-main1 test-common-container dilema-report">

      <div className="container-fluid">
        <CommomBanner
          banner={Dilemma?.full_banner_image}
          name={Dilemma?.name}
        />
      </div>



    </div>
  );
}

export default DilemaReport;
